export { default } from "./banner-component";
